module.exports = __webpack_public_path__ + "img/card-1.31aefb14.svg";